// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"d1cc510c","12":"575283f9","193":"c38d23a4","288":"08d0dcde","312":"1341319b","449":"bd2fbd5d","500":"869acae7","510":"2126b5b2","585":"99814bf3","654":"4f019f8e","703":"55998ff2","875":"0b39558e","915":"0559374e"}[chunkId] + ".chunk.js";
};